module.exports = __webpack_public_path__ + "img/logo_lsr.394b0e4b.png";